module.exports = __webpack_public_path__ + "img/chat-fill.592ed4ab.svg";